module.exports = __webpack_public_path__ + "img/07.1c0746f9.png";